import { Application } from '@enums/application.enums';
import { NEWSLETTER_LIMIT } from "@modules/monetize/components/newsletters/constants/news-letter.constant";
import { ensureEncoded } from '@utils/common.utils';

export enum API_URLS {
  intentAmount = 'api/intent-amount',
  login = 'users/users/login',
  signup = 'users/users',
  resend = 'users/users/resend-OTP',
  sendOtp = 'api/email/send-otp',
  verifyUser = 'users/users/verify',
  verifyOTP = 'api/email/verify-otp',
  completeProfile = 'users/users',
  forgotPassword = 'users/forgetPassword',
  setContent = '',
  courses = 'api/get_all_published_courses',
  category = 'api/category',
  updateCategory = 'users/category',
  homeUsers = 'users/home',
  preference = 'preferences',
  w9form = 'users/w9form',
  getUsers = 'users/users',
  users = 'users/users',
  blockListEmail = 'users/users/block/email_list',
  post = 'post/post',
  userPosts = 'post/users/post',
  redeemGuaranteedReply = 'api/redeem-guaranteed-reply',
  createPlans = 'api/createplans',
  getUsersWhitelabel = 'users/white_label',
  userPlan = 'api/userplan',
  getSavedPost = 'post/post/getsaved',
  savedPost = 'post/post/saved',
  feedPosts = 'post/users/feeds',
  followUser = 'users/users/follow',
  whitelabel = 'users/whiteLabel',
  discoverFeeds = 'post/discover_feeds',
  reset = 'users/user/resetPassword',
  changePassword = 'users/change-password',
  deleteAccount = 'post/delete-user',
  subscribeUserPlan = 'api/subscribe/userplan',
  postPayment = 'api/payment',
  suspendAccount = 'api/suspend-user-account',
  pauseAccount = 'api/pause-user-account',
  resumeAccount = 'api/resume-user-account',
  changeStoreFeatureStatus = 'users/users/store/item/feature',
  sharingUserDetails = 'users/users/follow',
  collaborators = 'users/userslist?collaborate=true',
  editUserPreferences = 'users/editUserPreferences',
  badges = 'api/badges',
  getSavedAndFollower = 'post/get-saved-posts-and-following',
  getExperieces = 'users/get_experience ',
  getUserWalletDetails = 'api/user-wallet',
  setEthereumAddress = 'api/set-ethereum-address',
  createExperience = 'users/create_experience',
  FollowerStatus = 'users/users/followers',
  createUserCourse = 'api/create_user_course',
  getAllUserCourses = 'api/get_user_course',
  Monetization = 'users/users',
  tipPayment = 'api/tip-payment',
  getUserCardDetails = 'api/user-cardDetails',
  categories = 'api/category',
  bankAccount = 'api/bank-Account',
  usersuggestFallowers = 'users/users/suggested-creators',
  getReportTags = 'admin/get-all-predefined-report-tags',
  storeStatus = 'api/shopify/user/store',
  stripaddAccount = 'tokens',
  addMoneyToWallet = 'api/add-moneywallet',
  goToCurrentPage = 'wallet/current-balance',
  addCard = 'api/add-Card',
  user_Wallet = 'api/user-wallet',
  user_bankDetails = 'api/user-bankDetails',
  user_cardDetails = 'api/user-cardDetails',
  user_subscribe = 'api/subscribe/user',
  stripeBank_Account = 'bank_account',
  suscribeuser = 'api/subscribe/user/',
  recived_history = 'api/recived-history',
  chat = 'api/chat',
  broadcast = 'broadcast',
  chatLogs = 'api/chat/logs',
  withdraw_history = 'api/withdraw-history',
  chatNew = 'api/chat/new',
  userSegment = 'users/users/save-user-segmentation-filter',
  getuserSegment = 'users/users/user-segmentation-filter',
  broadcastMessage = 'broadcast/message',
  userActivity = 'users/user-activities',
  loyaltyPoints = 'api/loyalty-points',
  restLoyaltyPoints = 'rest/loyalty-points',
  loyaltyPointsPackages = 'rest/loyalty-points-packages',
  purchasePoints = 'rest/purchase-points',
  loyaltyPointsActivities = 'api/loyalty-points-activities',
  loyaltyPointUnreadActivityCount = 'api/loyalty-point/unread-activity-count',
  loyaltyPointActivityReadStatus = 'api/loyalty-point/activity/read-status',
  merchandiseCreateOrder = 'api/merchandise/create/order',
  merchandiseOrderCheckout = 'api/shopify/checkout',
  merchandisePayment = 'api/order/merchandise',
  v2Payment = 'api/v2/payment',
  createPaymentIntent = 'rest/v2/create-payment-intent',
  payWithSavedCard = 'rest/v2/pay-with-saved-card',
  createSetupIntent = 'rest/v2/create-setup-intent',
  savedCards = 'rest/v2/saved-cards',
  checkPaymentStatus = 'api/check-payment-status',
  fundraiserContribute = 'api/fundraiser/contribute',
  fundraiserContributions = 'api/fundraiser/contributions',
  dmUnlock = 'api/dm-unlock',
  tipPaymentRecord = 'post/tip-payment-record',
  experienceCreateOrder = 'api/experience/create/order',
  experienceOrderCheckout = 'api/experience/checkout',
  eventTicketsPurchase = 'rest/events/tickets/purchase',
  ticketOrderCheckout = 'rest/events/tickets/checkout',
  experiencePayment = 'api/order/experience',
  bookingSlots = 'rest/booking/slots',
  bookingCheckAvailability = 'rest/booking/check-availability',
  bookingDetails = 'rest/booking/details',
  userEngagement = 'post/leaderBoard/user-engagement',
  withdrawal = 'api/withdraw-moneywallet',
  getUsersRefferedCreators = 'users/users-referred',
  bankaccount = 'api/bank-account',
  deleteCard = 'api/card-details',
  removeNFTFromAccount = 'api/remove-nfts-and-ethtoken',
  searchInsightUser = 'users/users/get-user-insights',
  searchInsight = 'api/user-segment',
  sendEmailNSms = 'api/user-segment/send-message',
  segmentationIntent = 'api/segmentation-intent',
  sendPushNotification = 'api/user-segment/push-notification',
  getHashtagList = 'admin/admin/hashtag?active=true',
  downloadUserInsightCsv = 'api/user-segment',
  searchUserAndHashtag = 'api/es-user-hashtag-list',
  hashtagPost = 'users/hashtag-posts?tag=',
  reportUser = 'post/report-post',
  reportForumPost = 'api/forum/report-post',
  reportComment = 'api/comment/report-post',
  reportForumComment = 'api/forum-comment/report-post',
  createChannel = 'api/create-channel',
  usersBlockList = 'users/users/block/list',
  markAsRead = 'api/mark-as-read',
  reportUserChat = 'api/chat/report',
  messagePayment = 'api/message-payment',
  externalMerch = 'api/external-product',
  refreshToken = 'users/users/refresh-token',
  addExternalNfts = 'api/external-nft',
  nfts = 'api/nfts',
  unblockUser = 'users/users/un-block',
  Notification = 'api/notification/get-user-badge-count',
  Award = 'api/award',
  ChatUserValidation = 'api/chat-user-validation',
  GetAllForumTopic = 'forum/get-all-forum-topic',
  GetMyForumTopic = 'api/forum/get-my-forum-topics',
  CreateForumTopic = 'api/forum/create-forum-topic',
  EarningAnalytics = 'api/earning-analytics',
  CreateForumPost = 'api/forum/create-post',
  collaboratorsList = 'api/es-collaborator-list',
  sharePost = 'post/share-post',
  suggestedCreators = 'api/course/suggested-creators',
  disconnectShopify = 'api/shopify/disconnect',
  previousMessages = 'api/getpreviousMessagesFromHttp',
  createGroup = 'api/create-group',
  groups = 'rest/groups',
  groupsAssign = 'rest/groups/assign',
  myGroups = 'rest/my-groups',
  groupsReorder = 'rest/groups/reorder',
  chatLogsUsersList = 'api/get-chatGroups-and-users',
  updateKeys = 'api/user-segment/integrate-user-account',
  getMailChimpList = 'api/user-segment/mail-chimp/lists',
  getklaviyoList = 'api/user-segment/kalviyo/lists',
  getsendinblueList = 'api/user-segment/send-in-blue/lists',
  getCoursesHistory = 'api/course/user',
  getTipsHistory = 'api/individual/tip',
  getExperiencesHistory = 'api/user/experience',
  getDirectMsgHistory = 'api/individual/post',
  userReferral = `api/leaderboard/create-user-refferal`,
  getCollections = 'api/collections',
  userCertificate = 'api/cloudfront/create-ssl-certificate',
  verifyCertificate = 'api/cloudfront/verify-ssl',
  deleteWhiteLabel = 'api/cloudfront/delete-ssl',
  userSslStatus = 'api/cloudfront/get-ssl-status',
  sesSetup = 'api/cloudfront/ses-setup',
  sesStatus = 'api/cloudfront/ses-status',
  sesVerify = 'api/cloudfront/ses-verify',
  sesDelete = 'api/cloudfront/ses-delete',
  publishCloudfront = 'api/cloudfront/publish',
  customerSupport = 'admin/admin/customer-support',
  getContentPost = 'post/users-post-with-title?title=',
  adminAdvertise = 'users/advertise',
  merchandiseOrderShippingRates = 'api/shopify/shipping_rates',
  calendarUnlink = 'rest/calendar/unlink',
  calendarStatus = 'rest/calendar/status',
  calendarOAuthCallback = 'rest/calendar/oauth-callback',
  displayEventCalendar = 'rest/event-header-config',
  getEventById = 'rest/events',
  eventHeaderConfig = 'rest/event-header-config',
  chatRoomContent = 'api/forum/update-setting',
  createEvent = 'rest/events',
  createOffer = 'api/coupons',
  offerLists = 'api/coupons',
  offerConfig = 'api/vip-offer-config',
  addScrollView = 'api/add-scroll-view',
  getStoreOrPostList = 'post/users-post-with-title?showProducts=true&title=[search]',
  eventLists = 'rest/events',
  blurImage = 'admin/blur-image',
  automatedMessage = 'api/automated-message',
  myPurchase = '/wallet/my-purchases/',
  subscriptionListing = '/wallet/my-purchases/subscription',
  coursesListing = '/wallet/my-purchases/courses',
  experiencesListing = '/wallet/my-purchases/experiences',
  tipsListing = '/wallet/my-purchases/tips',
  contentListing = '/wallet/my-purchases/content',
  messagesListing = '/wallet/my-purchases/messages',
  purchaseVIPListing = '/wallet/my-purchases/vip-offers',
  downloadableListing = '/wallet/my-purchases/downloadables',
  livestreamListing = '/wallet/my-purchases/livestreams',
  reorderStoreItems = 'admin/reorder/mystore',
  followRequest = 'admin/follow-request',
  addDownloadable = 'api/downloadables',
  downloadFile = 'admin/download-file',
  transactionHistory = 'api/transaction-history',
  seoLandingPage = 'api/seo-landing-page',
  marketingPage = 'api/admin/marketing-page',
  uploadFile = 'admin/upload-image',
  mononymAvailability = 'api/mononym-availability',
  creatorRequest = 'api/user/creator-request',
  createVeriffSession = 'api/create-veriff-session',
  pushNotification = 'api/notification/token ',
  withdrawSettings = 'admin/overall-withdrawal-setting',
  fulfillmentOrderCount = 'api/orders/count',
  fulfillmentOrderList = 'api/orders',
  fulfillmentOrderStatus = 'api/orders',
  orderDisputeMessage = 'api/send-direct-message-dispute',
  refundReasons = 'admin/refund-reason',
  refundRequest = 'api/refund-request',
  refundRequestStatus = 'api/refund-request-status',
  refundRequestCount = 'api/refund-request/count',
  refundRequestList = 'api/refund-request',
  refundTransactionDetails = 'api/refund/transaction',
  refundAction = 'api/refund-request',
  translateContent = 'api/translate-content',
  partialCreatorData = 'api/user/partial-creator-data',
  purchasesVIPOfferList = 'api/individual/vip-offer',
  deleteBandsintownArtist = 'rest/bandsintown/artist',
  sessionUpdate = 'api/session/update',
  sendOtpForBankAndCreditCard = 'api/payment-method/send-otp',
  verifyOtpForBankAndCreditCard = 'api/payment-method/verify-otp',
  syncBandsintownImport = 'rest/bandsintown/sync',
  orderPaymentDetail = 'api/order-payment-detail',
  purchasesDownloadableList = 'api/purchases/downloadables',
  purchasesLivestreamList = 'api/purchased/livestream',
  initiateEmailChange = 'api/users/initiate-email-change',
  verifyEmailChangeOTP = 'api/users/verify-email-change-otp',
  delegatePercentageAvailability = 'api/percent-availability',
  delegate = 'api/delegate',
  delegates = 'api/delegates',
  declineRequest = 'api/decline-request',
  delegateSendOtp = 'api/delegate/send-otp',
  delegateVerifyOtp = 'api/delegate/verify-otp',
  acceptDelegationRequest = 'api/accept-request',
  delegatedAccessList = 'api/delegated-access',
  switchToDelegate = 'api/switch-to-delegate',
  portfolio = 'api/portfolio',
  portfolioUser = 'api/portfolio/user',
  portfolioHeader = 'api/portfolio/header',
  portfolioAlbumContent = 'api/portfolio/album/content',
  portfolioContentAlbum = 'api/portfolio/content/album',
  portfolioContent = 'api/portfolio/content',
  portfolioContentDetail = 'api/portfolio/content/detail',
  dsp = 'api/dsp',
  portfolioReorder = 'api/portfolio/reorder',
  portfolioSequenceNumber = 'api/portfolio/sequence-number',
  portfolioEngagement = 'api/portfolio/engagement',
  portfolioRecordPlay = 'api/portfolio/record-play',
  portfolioAnalytics = 'api/portfolio-analytics',
  verifyBankAccount = 'api/verify-bank-account',
  transactionTypes = 'api/transaction-types',
  welcomeMessage = 'api/welcome-message',
  announcements = 'api/announcements',
  tipsTutorials = 'api/tips-tutorials',
  resourcesCount = 'api/creator-resources',
  createrResourceComments = 'api/creator-resource-comments',
  replyResourceComments = 'api/creator-resource-reply-comments',
  commentLike = 'api/like-comment',
  serviceProviders = 'admin/service-providers',
  serviceProvidersFilter = 'admin/admin/provider-types',
  serviceProvidersGetIntroduced = 'admin/service-providers/leads',
  likeCreatorResource = 'api/like/creator-resources',
  frequentQuestions = 'admin/frequent-questions',
  uploadVerificationDocument = 'api/upload-verification-document',
  newsletter = 'api/newsletter',
  newsletterSubscribers = 'api/newsletter/subscribers',
  newsletterSubscribe = 'api/newsletter/subscribe',
  newsletterUnsubscribe = 'api/newsletter/unsubscribe',
  newsletterPayment = 'api/newsletter/purchase',
  newsletterRecipients = 'api/newsletter/recipients',
  enquiryType = 'admin/enquiry-types',
  addDiscountCode = 'api/discount-code',
  discountCodeStatus = 'api/discount-code/status',
  applicableDiscountCode= 'api/apply/discount-code',
  getDiscountStore= 'api/store',
  newsletterAutosave = 'api/newsletter/autosave',
  getNewsletterPurchaseHistory = 'api/purchased/newsletter',
  initiateVeriffSession = 'api/initiate-veriff-session',
  getArticleDraft = 'post/drafts',
  saveArticleDraft = 'post/drafts',
  aiGenerate = 'api/ai/generate',
  liveStreamChannel = 'api/available-channel',
  liveStreamPolling = 'api/livestream-heartbeat',
  liveStream = 'api/livestream',
  joinLivestream = 'api/join-livestream',
  livestreamHeartbeat = 'api/livestream-heartbeat',
  livestreamReaction = 'api/livestream/reaction',
  getActiveLiveStreams = 'api/active/livestreams',
  purchaseLivestream = 'api/livestream/purchase',
  livestreamPresentItem = 'api/livestream/present-item',
  getActiveSubscribers = 'api/active-subscribers',
  getNewsLetterInsight= 'api/newsletter-recipients',
  leaveLivestream = 'api/leave-livestream',
  importFans = 'api/import-fans',
  inviteFans = 'api/invite-fans',
  importStatus = 'api/import-status',
  importStatusUsers = 'api/import-status/users',
  livestreamModeration = 'api/livestream/moderation',
  postBookADemo='users/demo-video-invite-mail',
  consumeDMCredits = 'api/consume-free-dm-credit',
  getSpecificStores = 'api/store/specific_item',
  LINK_IN_BIO = 'api/link-in-bio',
  LINK_IN_BIO_MANAGE = 'api/link-in-bio/manage',
  GENERAL_ACTIONS = 'api/lib/general-actions',
  PURCHASED_MESSAGES = 'api/purchased-dms',
  getFundraiserStores = 'api/store/all?shopType=fundraiser',
  referralCode = 'users/generate-referral-code',
  API_ADS_EARNING = 'users/ads-earning',
  USER_AD_PREFERENCE = 'users/ad-preference',
  BRAND_PREFERENCES = 'users/brand/preferences',
  NEW_BRANDS = 'users/new-brands',
  getSkyscraperAds = 'post/user/ads',
  trackAd = 'users/ads/track',
  BRAND_CATEGORIES = 'users/brand-categories',
  BRANDS = 'users/brands?user_type=creator',
  portfolioIndividualSongsContent = 'api/portfolio/content',
  checkImportedStatus = 'api/check-imported-status',
  optOutUser = 'api/opt-out-user',
  portfolioContentPurchase = 'api/portfolio/content/purchase',
  consentSharedByMe = 'api/consents/shared-by-me',
  portfolioListing = 'portfolio',
  myTickets = 'rest/my-tickets',
  ticketsListing = '/wallet/my-purchases/tickets',
  postTopics = 'post/topics',
  usersInquiry= 'users/inquiry',
  previewPreview= 'users/price-preview',
  storeMerchandise= 'api/store/merchandise'
}

export const APIENDPOINT = {
  deleteFan: (fanEmail: string) => `api/imported-user/${encodeURIComponent(fanEmail)}`,
  reorderVipSequence: () => `api/coupons/sequence-number`,
  updateExternalNfts: (id) => `api/external-nft/${id}`,
  updateExternalMerch: (id) => `api/external-product/${id}`,
  courseProgress: (courseId) => `api/user_course_progress/${courseId}`,
  assessmentResults: (courseId, lessonId) =>
    `api/assessment_quiz_result/${courseId}/${lessonId}`,
  attemptLessonQuiz: (courseId, lessonId) =>
    `api/attempt_lesson_quiz/${courseId}/${lessonId}`,
  collabList: (onInterestBasis, sk, pk) =>
    `admin/collaborators-list?onInterstBasis=${onInterestBasis}&last_evaluated_key_sk=${encodeURIComponent(sk)}&last_evaluated_key_pk=${encodeURIComponent(pk)}`,
  collabListWithoutSK: (onInterestBasis) =>
    `admin/collaborators-list?onInterstBasis=${onInterestBasis}`,
  updateCourseProgress: (courseId) => `api/course_progress/${courseId}`,
  updateProgress: (courseId) => `api/update_course_progress/${courseId}`,
  lessonDetails: (cid, lid) => `api/get_lesson_by_id/${cid}/${lid}`,
  savedPostCourses: (pk, sk) =>
    `api/get_all_published_courses?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  lessionDetails: (id) => `api/get_all_lesson/${id}`,
  courseDetails: (id) => `api/getCourseById/${id}`,
  deleteExperience: (sk) => `users/remove_experience/${sk}`,
  experiencesPages: (pk, sk) =>
    `users/get_experience?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  editExperience: (id) => `users/edit_experience/${id}`,
  getExperienceDetails: (id) => `users/getExperienceById/${id}`,
  subCategory: (key) => `api/category/subcategory/${key}`,
  categoryDetails: (key) => `api/category/users/${key}`,
  userPosts: (pk, sk) =>
    `users/users/post?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getPost: (postId, userId) => `post/post_details/${postId}/details/${userId}`,
  getAdDetails: (pk, sk) => `users/ads-details?pk=${encodeURIComponent(pk)}&sk=${encodeURIComponent(sk)}`,
  getUsersStore: (userEmail, fValue, countOnly = false, isMonetize = false) =>
    `users/users/store/${userEmail}?filter=${fValue}&countOnly=${countOnly}&isMonetize=${isMonetize}`,
  deletePost: (postId) => `post/postDelete/${postId}`,
  likePost: (pk, sk) => `post/like/${pk}/postlike/${sk}`,
  followRequestPages: (pk: string, sk: string) =>
    `admin/follow-request?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  deleteLike: (pk, sk) => `post/like/${pk}/${sk}`,
  getWhiteLabelConfig: (sk) => `users/white_label_by_website?web_url=${sk}`,
  comment: (pk, sk) => `post/comment/${pk}/add/${sk}`,
  getFeatureListOfUser: (email) => `users/users/feature/items/${email}`,
  deleteComment: (email, postId, commentId, isPinned) =>
    `post/comment/${email}/${postId}/${commentId}?is_pinned=${isPinned}`,
  categoryDet: (pk, sk) =>
    `?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  commentPages: (pSkKey, pk, sk) =>
    `post/comment/${pSkKey}?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getComment: (
    pSkKey,
    pageNumber: number = Application.ONE,
    isPinned = false
  ) => `post/comment/${pSkKey}?pageNumber=${pageNumber}&is_pinned=${isPinned}`,
  commentLike: (postId, commentId) =>
    `post/like/comment/${postId}/add/${commentId}`,
  commentUnLike: (postId, commentId) =>
    `post/like/uncomment/${postId}/unlike/${commentId}`,
  delete_subscriptionPlan: (subscriptionId) => `api/userplan/${subscriptionId}`,
  enableAutoRenewalSubscription: (subscriptionId) =>
    `api/subscribe/user/restart-auto-renewal/${subscriptionId}`,
  editUserPlan: (subscriptionId) => `api/userplan/${subscriptionId}`,
  replyComments: (postId, commentId, userId) =>
    `post/replyComment/${userId}/post/${commentId}/${postId}`,
  replyGetComments: (commentId, pageNumber: number = Application.ONE) =>
    `post/reply/${commentId}?pageNumber=${pageNumber}`,
  enrollCoursePayment: (courseId) => `api/enroll-course-payment/${courseId}`,
  enrollIntoCourse: (courseId, postUserID) =>
    `api/enroll_into_course/${courseId}${postUserID}`,
  individualCoursePurchase: (courseId, postUserID) => `api/individual-course-purchase/${courseId}${postUserID}`,
  replyCommentPages: (commentId, pk, sk) =>
    `post/reply/${commentId}?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  feedPostPages: (pk, sk, lastShowedUser) =>
    `post/users/feeds?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}&last_showed_user=${lastShowedUser}`,
  discoverPostPages: (pk, sk) =>
    `post/discover_feeds?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  savedPostPages: (pk, sk) =>
    `post/post/getsaved?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getFeatureMetaData: (pk, sk) => `users/users/item/metadata?pk=${pk}&sk=${sk}`,
  user: (username) => `api/user_by_username/${username}`,
  idByUsername: (username: string, isFollower: boolean) =>
    `api/id-by-username?username=${encodeURIComponent(username)}&is_follower=${isFollower}&is_private=true&only_followers_can_access_content=true`,
  linkInBioByUsername: (username) => `api/link-in-bio/url/${username}`,
  otherPosts: (userId) => `post/users/post/${userId}`,
  otherPostPages: (userId, pk, sk) =>
    `post/users/post/${userId}?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  followersList: (pk) => `users/users/following/${pk}`,
  pollAnswer: (postId, userId) => `post/polls/${postId}/update/${userId}`,
  pinPost: (postId) => `post/posts/pin/${postId}`,
  unfollowUser: (userId) => `users/users/follow/${userId}`,
  getCourseById: (courseId) => `api/getCourseById/${courseId}`,
  deleteCourse: (courseId) => `api/remove_course/${courseId}`,
  createLesson: (courseId) => `api/add_lesson_to_course/${courseId}`,
  editCourse: (courseId) => `api/edit_user_course/${courseId}`,
  getAllLesson: (courseId) => `api/get_all_lesson/${courseId}`,
  deleteLesson: (courseId, lessonId) =>
    `api/remove_lesson_from_course/${courseId}/${lessonId}`,
  getLessonById: (courseId, lessonId) =>
    `api/get_lesson_by_id/${courseId}/${lessonId}`,
  editLessonById: (courseId, lessonId) =>
    `api/edit_lesson_course/${courseId}/${lessonId}`,
  coursesPages: (pk, sk) =>
    `api/get_user_course?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getAllLessonPages: (courseId, pk, sk) =>
    `api/get_all_lesson/${courseId}?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  unSavedPost: (postId) => `post/post/saved/${postId}`,
  postFilter: (type, userId = null, topicTags = [], pk = null, sk = null) => {
    let url = `users/users/post${userId ? '/' + userId : ''}?topic_ids=${topicTags.join(',')}`;
    if (type) {
      url += `&filter_by=${type}`;
    }
    if (pk && sk) {
      url += `&last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`;
    }
    return url;
  },
  publishCourse: (courseId) => `api/publish_course/${courseId}`,
  unPublishCourse: (courseId) => `api/unpublish_course/${courseId}`,
  shopifyConnect: (shopId) => `api/shopify?shop=${shopId}`,
  updateQuality: (id) => `api/change/product/state/${id}`,
  getMerchandiseOrderDetail: (sk) => `api/merchandise/order/metadata?sk=${sk}`,
  productPages: (pk, sk, collectionKey) =>
    `api/products/${collectionKey}?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getStoreProduct: (id) => `api/product?product_id=${id}`,
  getMerchandiseStoreProduct: (id, creatorId) =>
    `api/product?product_id=${id}&creator_id=${creatorId}`,
  getNfts: (id) => `api/nft/${id}`,
  updateProductStatus: (id) => `api/change/product/state/${id}`,
  fetchPostStatus: (postId, userId) =>
    `post/post/locked/${postId}/status/${userId}`,
  withdraw_history: (startDate, EndDate) =>
    `api/withdraw-history?start_date=${startDate}&end_date=${EndDate}`,
  withdraw_history_pages: (sd, ed, pk, sk) =>
    `api/withdraw-history?start_date=${sd}&end_date=${ed}&last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  user_subscribe: () => 'api/userplan',
  user_subscribe_pages: (pk, sk) =>
    `api/subscribe/user?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  recived_history: (filterKey) => `api/recived-history?end_date=${filterKey}`,
  recived_historyPages: (filterKey, pk, sk) =>
    `api/recived-history?end_date=${filterKey}?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  updateProduct: (id) => `api/products/${id}`,
  getChat: (chartData) =>
    `api/chat?sid=${chartData.sid}&receiver=${chartData.receiver}&limits=${chartData.limits}&nextPage=${chartData.nextPage}&previousPage=${chartData.previousPage}`,
  getChannelDetailsById: (id) => `api/chat?sid=${id}`,
  getBroadCastHistory: (id) => `broadcast/logs/${id}`,
  merchandise: () => 'api/merchandise/orders',
  merchandise_pages: (pk, sk, course) =>
    `api/merchandise/orders?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}&filter=${course}`,
  getFollowers: (userId) => `users/users/followers/${userId}`,
  getFollowerPages: (userId, pk, sk, gsi1pk, gsi1sk) =>
    `users/users/followers/${userId}?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}&last_evaluated_key_gsi1pk=${gsi1pk}&last_evaluated_key_gsi1sk=${gsi1sk}`,
  getFollowing: (pk) => `users/users/following/${pk}`,
  getSubscribedUsers: (email) => `users/users/subscribers/${email}`,
  getFollowingPages: (userId, pk, sk) =>
    `users/users/following/${userId}?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  userActivityPages: (pk, sk) =>
    `users/user-activities?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getMarchadice: (filterValue) => `api/products-name?title=${filterValue}`,
  downLoadRecivedHistory: (filterDate) =>
    `api/csv-recived-history?end_date=${filterDate}`,
  userActivityFilter: () => `users/user-activities?filter=unread`,
  readActivity: (sk) => `users/activity/read-status/${sk}`,
  readAllActivity: () => 'users/activity/all-read',
  loyaltyLeaderboard: (userId: string, startDate: number, endDate: number) =>
    `api/leaderboard/loyalty-points/${encodeURIComponent(userId)}?startDate=${startDate}&endDate=${endDate}`,
  loyaltyPointsActivities: (
    creatorId: string,
    limit: number = 20,
    lastEvaluatedKeyPk: string = '',
    lastEvaluatedKeySk: string = ''
  ) => {
    let url = `${API_URLS.loyaltyPointsActivities}?creator_id=${encodeURIComponent(creatorId)}&limit=${limit}`;
    if (lastEvaluatedKeyPk && lastEvaluatedKeySk) {
      url += `&last_evaluated_key_pk=${encodeURIComponent(lastEvaluatedKeyPk)}&last_evaluated_key_sk=${encodeURIComponent(lastEvaluatedKeySk)}`;
    }
    return url;
  },
  loyaltyPointsPackages: (creatorId: string) =>
    `${API_URLS.loyaltyPointsPackages}/${encodeURIComponent(creatorId)}`,
  loyaltyPoints: (creatorId: string) =>
    `${API_URLS.restLoyaltyPoints}/${encodeURIComponent(creatorId)}`,
  loyaltyUnreadActivityCount: (creatorId: string) =>
    `${API_URLS.loyaltyPointUnreadActivityCount}?creator_id=${encodeURIComponent(creatorId)}`,
  fanPoints: (creatorId: string, fanId: string) =>
    `api/fan-points/${encodeURIComponent(creatorId)}?fanId=${encodeURIComponent(fanId)}`,
  blockUser: (userId) => `users/users/block/${userId}`,
  getBroadCastHistoryPages: (pk, sk, id) =>
    `broadcast/logs/${id}?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  mostEngage: (startDate, endDate, email, downloadCSV = false, limit = 5, offset = 0, is_insigits = true, search = '', sortByName = '', sortBySession = '') =>
    `api/leaderboard/most-engaged/${startDate}/${endDate}/${email}?downloadCSV=${downloadCSV}&limit=${limit}&offset=${offset}&is_insigits=${is_insigits}&search=${search}&sortByName=${sortByName}&sortBySession=${sortBySession}`,
  topSupporter: (startDate, endDate, email, downloadCSV = false, limit = 5, offset = 0, is_insigits = true, search = '', sortByName = '', sortBySession = '') =>
    `api/leaderboard/top-supporters/${startDate}/${endDate}/${email}?downloadCSV=${downloadCSV}&limit=${limit}&offset=${offset}&is_insigits=${is_insigits}&search=${search}&sortByName=${sortByName}&sortBySession=${sortBySession}`,
  userSegmentData: () => `users/users/user-segmentation-filter`,
  deleteReply: (postId, commentId, replyId, isPinned) =>
    `post/reply/delete/${commentId}/post/${replyId}?post_id=${postId}&is_pinned=${isPinned}`,
  subCategories: (key) => `api/category/get-sub-category/${key}`,
  getMostRefferal: (startDate, endDate, email, downloadCSV = false, limit = 5, offset = 0, is_insigits = true, search = '', sortByName = '', sortBySession = '') =>
    `api/leaderboard/most-referrals/${startDate}/${endDate}/${email}?downloadCSV=${downloadCSV}&limit=${limit}&offset=${offset}&is_insigits=${is_insigits}&search=${search}&sortByName=${sortByName}&sortBySession=${sortBySession}`,
  homeSubCategories: (category, subCategory, searchKey, url = '') =>
    `admin/category/users?category_id=${encodeURIComponent(
      category
    )}&sub_category_id=${encodeURIComponent(subCategory)}&url=${encodeURIComponent(url)}&search=${searchKey}`,
  likedUsers: (postId) => `post/like/getData/${postId}`,
  likedUserPages: (postId, pk, sk) =>
    `post/like/getData/${postId}?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  followingUserPages: (email, pk, sk, searchData) =>
    `users/users/following/${email}?search=${searchData}&last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  collabUserList: (search, pageSize, currentPage) =>
    `api/es-collaborator-list?search_value=${search}&page_size=${pageSize}&current_page=${currentPage}`,
  getSingleTopic: (topicId) => `api/forum/get-forum-topic/${topicId}`,
  updateForumTopic: (topicId) => `api/forum/update-forum-topic/${topicId}`,
  deleteForumTopic: (topicId) => `api/forum/delete-forum-topic/${topicId}`,
  updateForumPost: (postId) => `api/forum/update-post/${postId}`,
  deleteForumPost: (postId) => `api/forum/delete-post/${postId}`,
  deleteForumPostOtherUser: (postId, forumUser) =>
    `api/forum/delete-post/${postId}/${forumUser}`,
  forumMembers: (pk, sk, email) =>
    `api/forum/get-all-members/${email}?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  forumPosts: (pk, sk) =>
    `api/forum/get-all-post?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  forumTopics: (pk, sk) =>
    `api/forum/get-all-forum-topic?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  forumLike: (userId, postId) => `api/forum/like-post/${postId}/${userId}`,
  forumDislike: (userId, postId) => `api/forum/unlike-post/${postId}/${userId}`,
  getForumComments: (postId, email, pageNumber: number = Application.ONE) =>
    `api/forum/get-all-comments/${postId}?pageNumber=${pageNumber}&email=${email}`,
  deleteForumPostComment: (userId, postId, commentId) =>
    `api/forum/delete-comment/${postId}/${userId}/${commentId}`,
  replyForumComment: (commentId, pageNumber: number = Application.ONE) =>
    `api/forum/reply/${commentId}?pageNumber=${pageNumber}`,
  commentOnForumPost: (userId, postId) =>
    `api/forum/comment-on-post/${postId}/${userId}`,
  replyOnForumComment: (postId, commentId) =>
    `api/forum/reply-comment/${commentId}/${postId}`,
  deleteForumReplyComment: (commentId, replyId, postId, forumUserEmail) =>
    `api/forum/delete-reply-comment/${commentId}/${replyId}?post_id=${postId}&forum_user=${forumUserEmail}`,
  likeForumComment: (postId, commentId) =>
    `api/forum/like/comment/${postId}/${commentId}`,
  unlikeForumComment: (postId, commentId) =>
    `api/forum/like/comment/${postId}/${commentId}`,
  forumCommentPages: (pSkKey, pk, sk) =>
    `api/forum/get-all-comments/${pSkKey}?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  forumReplyCommentPages: (commentId, pk, sk) =>
    `post/reply/${commentId}?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getForumPost: (postId, userId) => `api/forum/get-post/${postId}/${userId}`,
  getForumPosts: (userId) => `api/forum/get-all-post/${userId}`,
  getFormMembers: (userId) => `api/forum/get-all-members/${userId}`,
  getAllForumTopic: (userId) => `api/forum/get-all-forum-topic/${userId}`,
  getAwards: (email, pk, sk) =>
    `api/award/${email}?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getAllEngagementPosts: (startDate, endDate) =>
    `api/get-all-post-insight?start_date=${startDate}&end_date=${endDate}`,
  getEngagementAnalytics: (startDate, endDate) =>
    `api/engagement-analytics?start_date=${startDate}&end_date=${endDate}`,
  getEngagementGraphAnalytics: (startDate, endDate) =>
    `api/get-view-analytics-graph?start_date=${startDate}&end_date=${endDate}`,
  getEngagementAnalyticsCSV: (startDate, endDate, action) =>
    `api/engagement-analytics?start_date=${startDate}&end_date=${endDate}&action=${action}`,
  getCourseEnableStatus: (sk) => `api/course/enrolled/${sk}`,
  deleteSubscriber: (sk) => `api/subscribe/plans/${sk}`,
  deleteComplementarySubscription: (planSk: string, userId: string) =>
    `api/subscribe/user/${encodeURIComponent(planSk)}?user_id=${userId}`,
  getContent: (type, searchKey) =>
    `post/users-post-title?type=${type}&title=${searchKey}`,
  shopifyCallBack: (code, shop, state) =>
    `api/shopify/callback?code=${code}&shop=${shop}&state=${state}`,
  getSubscriptionDetails: (userId, subsId) => `api/plans/${userId}/${subsId}`,
  addMailChimpMembers: (listId) =>
    `api/user-segment/mail_chimp/lists/${listId}/members`,
  addKlaviyoMembers: (listId) => `api/user-segment/klaviyo/${listId}/member`,
  addSeninblueMembers: (listId) =>
    `api/user-segment/send-in-blue/${listId}/member`,
  getCoursesHistoryPages: (pk, sk) =>
    `api/course/user?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getTipsHistoryPages: (pk, sk) =>
    `api/individual/tip?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getExperiencesHistoryPages: (pk, sk) =>
    `api/user/experience?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getDirectMsgHistoryPages: (pk, sk) =>
    `api/individual/post?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getMessagesHistoryPages: (pk, sk) =>
    `api/purchased-dms?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  userMaxPurchaseQuantity: (productId) =>
    `api/overallProductQuantity/${productId}`,
  Products: (collectionKey) => `api/products/${collectionKey}`,
  deleteSegment: (filterName) => `users/save-user-segment/${filterName}`,
  createShortenUrl: () => 'api/create-short-url',
  getFullUrlFromShortUrl: () => 'api/get-short-url',
  adminHashTags: (pk, sk, gsi1pk, gsi1sk) =>
    `admin/admin/hashtag?active=true&last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}&last_evaluated_key_gsi1pk=${gsi1pk}&last_evaluated_key_gsi1sk=${gsi1sk}`,
  collabPermission: (sk: string, pk: string, status: boolean) =>
    `post/collab-permission/${sk}/update/${pk}?permission=${status.toString()}`,
  removeCollaboration: (email: string, postId: string) =>
    `admin/remove-collaboration/${encodeURIComponent(email)}/${encodeURIComponent(postId)}`,
  getCreatorSubLevel: (catId) =>
    `admin/admin/get-all-level-sub-category/${catId}`,
  searchUserAndHashtag: (searchKey, pageSize) =>
    `api/es-user-hashtag-list?search_value=${searchKey}&page_size=${pageSize}`,
  editOffer: (offerId) => `api/coupons/${offerId}`,
  editOfferStatus: (offerId) => `api/coupons/status/${offerId}`,
  claimFreeVipCode: (offerId) => `api/coupons/claim/${offerId}`,
  getDownloadableById: (id) => `api/downloadables_by_id/${id}`,
  getBandsintownArtistDetails: (artistName: string, appId: string) =>
    `rest/bandsintown/${artistName}/${appId}`,
  syncBandsintownArtistDetails: (artistId, appId: string) =>
    `rest/bandsintown/${artistId}/${appId}`,
  giveAwayAnswer: (userId, postId) =>
    `post/users/${userId}/posts/${postId}/answers`,
  fetchGiveAwayAnswers: (postId, pageNumber = 1, isDownload = false) =>
    `post/posts/${postId}/answers?pageNumber=${pageNumber}${
      isDownload ? '&isDownload=true' : ''
    }`,
  goToCourse: (course, pk) =>
    `dashboard/merchandise-details/${course?.receiver_details?.user_name}&${
      course?.receiver_details?.gsi4pk
    }/${encodeURIComponent(pk)}/${encodeURIComponent(course?.course_id)}/store`,
  updateNotificationSetting: (email) => `api/notification/${email}`,
  getFulfillmentOrderDetails: (pk: string, sk: string) => {
    return `api/orders/${encodeURIComponent(pk)}/${encodeURIComponent(sk)}`;
  },
  updateProductLocking: (id) => `api/change/product/state/${id}`,
  getTaxonomyByUserId: (id) => `admin/user-category/${id}`,
  getVIPPurchasePages: (pk, sk) =>
    `api/individual/vip-offer?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getDownloadablePurchasePages: (pk, sk) =>
    `api/purchases/downloadables?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getLivestreamPurchasePages: (pk, sk) =>
    `api/purchased/livestream?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getPortfolioPurchasePages: (pk, sk) =>
    `api/portfolio/content/purchase?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`,
  getMyTicketsPages: (pk: string, sk: string, limit = 50) =>
    `${API_URLS.myTickets}?limit=${limit}&last_evaluated_key_pk=${encodeURIComponent(
      pk
    )}&last_evaluated_key_sk=${encodeURIComponent(sk)}`,
  getDelegationList: () => {
    return `api/delegates?delegate=${encodeURIComponent('Delegate Access')}`;
  },
  delegateMonthlySummary: (
    pk,
    year,
    isDownloadCSV,
    isDelegatedAccess = false
  ) => {
    let endpoint = `api/delegate/payments/monthly-summary/${encodeURIComponent(pk)}?year=${year}&downloadCSV=${isDownloadCSV}`;
    if (isDelegatedAccess) {
      endpoint = `${endpoint}&delegateAccess=true`;
    }
    return endpoint;
  },
  delegateMonthlyTransaction: (
    pk,
    year,
    month,
    isDownloadCSV,
    isDelegatedAccess = false
  ) => {
    let endpoint = `api/delegate/payments/monthly-transactions/${encodeURIComponent(pk)}?year=${year}&month=${month}&downloadCSV=${isDownloadCSV}`;
    if (isDelegatedAccess) {
      endpoint = `${endpoint}&delegateAccess=true`;
    }
    return endpoint;
  },
  delegateTransactionDetails: (pk, sk) => {
    return `api/transaction/${encodeURIComponent(pk)}/detail/${encodeURIComponent(sk)}`;
  },
  userByTaxonomy: (searchVal, pk: string = '', sk: string = '') => {
    let url = 'users/by-taxonomy';
    if (searchVal) {
      searchVal = encodeURIComponent(searchVal);
      url = `${url}?search=${searchVal}`;
    }
    if (pk && sk) {
      url = `${url}${searchVal ? '&' : '?'}last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}`;
    }
    return url;
  },
  deleteVipOffer: (id) => {
    return `api/coupons/${id}`;
  },
  deleteShopifyMerchandise: (id) => {
    return `api/product/${id}`;
  },
  mailingList: () => 'api/mailing-list',
  deleteMailingList: (id) => `api/mailing-list/${id}`,
  chatEdit: (id, search_key) => `api/chat/edit/${id}?search_key=${search_key}`,
  getNewsLetter: (creatorId, newsletterId) => `${API_URLS.newsletter}/user/${creatorId}/detail/${newsletterId}`,
  loadNewsletters: (creatorId) => `${API_URLS.newsletter}?creator_id=${creatorId}&limit=${NEWSLETTER_LIMIT}`,
  userSubscribe: (isWhiteLabel, hostName) => `${API_URLS.user_subscribe}?is_white_label=${isWhiteLabel}&hostName=${hostName}`,
  fetchDiscountCode: (pk, sk, type) =>
    `api/apply/discount-code?pk=${pk}&sk=${sk}&monetizeType=${type}`,
  removeDiscountCode: (orderSK)=>`api/remove/discount-code/${orderSK}`,
  getNewsletterPurchaseHistoryPages: (pk, sk, isWhiteLabel, hostName) =>
    `${API_URLS.getNewsletterPurchaseHistory}?last_evaluated_key_pk=${pk}&last_evaluated_key_sk=${sk}&is_white_label=${isWhiteLabel}&hostName=${hostName}`,
  getPortfolioData : (userPk:string,portfolioSk:string)=>{
    return `api/portfolio/user/${userPk}/${ensureEncoded(portfolioSk)}`
  },
  getEventDetails: (eventSk:string,eventPk:string)=>{
     return `rest/event-details/${ensureEncoded(eventPk)}/${ensureEncoded(eventSk)}`
  },
  eventById: (eventId: string) => `${API_URLS.getEventById}/${encodeURIComponent(eventId)}`,
  eventAttendees: (eventId: string, creatorId: string) => {
    const q = new URLSearchParams();
    q.set('creator_id', creatorId);
    return `rest/event/attendees/${encodeURIComponent(eventId)}?${q.toString()}`;
  },
  eventPurchasedTickets: (eventId: string, creatorId: string) => {
    const q = new URLSearchParams();
    q.set('creator_id', creatorId);
    return `rest/event/purchased-tickets/${encodeURIComponent(eventId)}?${q.toString()}`;
  },
  eventTickets: (
    eventId: string,
    params: {
      status: 'USED' | 'UNUSED';
      search?: string;
      limit?: number;
      lastEvaluatedKey?: { pk: string; sk: string } | null;
    }
  ) => {
    const base = `${API_URLS.getEventById}/${encodeURIComponent(eventId)}/tickets`;
    const q = new URLSearchParams();
    q.set('status', params.status);
    const limit = params.limit ?? 50;
    q.set('limit', String(limit));
    const term = params.search?.trim();
    if (term) {
      q.set('search', term);
    }
    if (params.lastEvaluatedKey?.pk && params.lastEvaluatedKey?.sk) {
      q.set('last_evaluated_key_pk', params.lastEvaluatedKey.pk);
      q.set('last_evaluated_key_sk', params.lastEvaluatedKey.sk);
    }
    return `${base}?${q.toString()}`;
  },
  ticketPurchasers: (
    eventId: string,
    params: {
      levelId: string;
      search?: string;
      limit?: number;
      lastEvaluatedKey?: { pk: string; sk: string; gsi1pk: string; gsi1sk: string } | null;
    }
  ) => {
    const base = `rest/ticket-purchasers/${encodeURIComponent(eventId)}`;
    const q = new URLSearchParams();
    q.set('level_id', params.levelId);
    q.set('limit', String(params.limit ?? 20));
    const term = params.search?.trim();
    if (term) {
      q.set('search', term);
    }
    if (params.lastEvaluatedKey) {
      q.set('last_evaluated_key_pk', params.lastEvaluatedKey.pk);
      q.set('last_evaluated_key_sk', params.lastEvaluatedKey.sk);
      q.set('last_evaluated_key_gsi1pk', params.lastEvaluatedKey.gsi1pk);
      q.set('last_evaluated_key_gsi1sk', params.lastEvaluatedKey.gsi1sk);
    }
    return `${base}?${q.toString()}`;
  },
  deleteEventTicketLevel: (eventId: string, levelId: string) =>
    `${API_URLS.getEventById}/${encodeURIComponent(eventId)}/ticket-levels/${encodeURIComponent(levelId)}`,
  ticketRedeem: (ticketId: string) =>
    `rest/tickets/${encodeURIComponent(ticketId)}/redeem`,
  getActiveDiscountCodesCount: (gsi4pk: string) => `api/discount-code/count/${gsi4pk}`,
  aiPollContent: (record_pk: string) => `api/ai-generated-content?record_pk=${encodeURIComponent(record_pk)}`,
  deleteOccupiedChannel: (channelId: string) => `api/occupied-channel/${channelId}`,
  getLiveStreamById: (livestreamId: string) => `api/livestream/${ensureEncoded(livestreamId)}`,
  getLivestreamDetails: (livestream_id: string, creator_id: string, param) => `api/livestream-details/${ensureEncoded(livestream_id)}/${creator_id}?${param}=true`,
  getCurrentViewers: (channelId: string) => `api/current-viewers/${channelId}`,
  insightsFans: (downloadCSV = false, limit = 5, offset = 0, is_insigits = true, search = '', sortByName = '', sortBySession = '', fanFilter = 'all') =>
    `api/insights-fans?downloadCSV=${downloadCSV}&limit=${limit}&offset=${offset}&is_insigits=${is_insigits}&search=${search}&sortByName=${sortByName}&sortBySession=${sortBySession}&filter=${fanFilter}`,
  fanDetails: (fanId: string, isImported: boolean = false, isImportedRegister: boolean = false) => {
    let url = `api/insights-fans/${fanId}`;
    if (isImported) {
      url += `?is_imported=true&is_imported_register=${isImportedRegister}`;
    }
    return url;
  },
  fanTransactions: (fanId: string, downloadCSV: boolean, startDate: string = '', endDate: string = '', lastEvaluatedKey?: any) => {
    let url = `api/fan-transactions/${fanId}?downloadCSV=${downloadCSV}&limit=50`;
    if (startDate) {
      url += `&start_date=${startDate}`;
    }
    if (endDate) {
      url += `&end_date=${endDate}`;
    }
    if (lastEvaluatedKey) {
      url += `&last_evaluated_key_sk=${encodeURIComponent(lastEvaluatedKey?.sk)}&last_evaluated_key_pk=${encodeURIComponent(lastEvaluatedKey?.pk)}`;
    }
    return url;
  },
  fanEngagement: (fanId: string, downloadCSV: boolean, startDate: string = '', endDate: string = '', lastEvaluatedKey?: any) => {
    let url = `api/fan-engagement/${fanId}?downloadCSV=${downloadCSV}&limit=50`;
    if (startDate) {
      url += `&start_date=${startDate}`;
    }
    if (endDate) {
      url += `&end_date=${endDate}`;
    }
    if (lastEvaluatedKey) {
      url += `&last_evaluated_key_sk=${encodeURIComponent(lastEvaluatedKey?.sk)}&last_evaluated_key_pk=${encodeURIComponent(lastEvaluatedKey?.pk)}`;
    }
    return url;
  },
  fanRecruitment: (fanId: string, downloadCSV: boolean, startDate: string = '', endDate: string = '', lastEvaluatedKey?: any) => {
    let url = `api/fan-recruitment/${fanId}?downloadCSV=${downloadCSV}&limit=50`;
    if (startDate) {
      url += `&start_date=${startDate}`;
    }
    if (endDate) {
      url += `&end_date=${endDate}`;
    }
    if (lastEvaluatedKey) {
      url += `&last_evaluated_key_sk=${encodeURIComponent(lastEvaluatedKey?.sk)}&last_evaluated_key_pk=${encodeURIComponent(lastEvaluatedKey?.pk)}`;
    }
    return url;
  },
  updateFanNotes: () => `api/fan-note`,
  PROFILE_VIEW : (id)=>`api/profile-view/${id}`,
  livestreamActiveViewers: (livestreamId, creator_id) => `api/livestream/active-viewers/${encodeURIComponent(livestreamId)}?limit=10&creator_id=${creator_id}`,
  welcomeMessage: (id: string) => `api/welcome-message/${id}`,
  getFundraiserContributions: (creatorId: string, fundraiserId: string, limit: number = 10, lastEvaluatedKeyPk?: string, lastEvaluatedKeySk?: string, downloadCSV: boolean = false, message: boolean = true) => {
    let url = `${API_URLS.fundraiserContributions}/user/${encodeURIComponent(creatorId)}/post/${encodeURIComponent(fundraiserId)}?limit=${limit}&message=${message}`;
    if (downloadCSV) {
      url += `&downloadCSV=true`;
    }
    if (lastEvaluatedKeyPk && lastEvaluatedKeySk) {
      url += `&last_evaluated_key_pk=${encodeURIComponent(lastEvaluatedKeyPk)}&last_evaluated_key_sk=${encodeURIComponent(lastEvaluatedKeySk)}`;
    }
    return url;
  },
  getAlbumContent: (albumSk:string, type:string, creatorId?:string)=>{
    let url = `api/portfolio/album/content/${ensureEncoded(albumSk)}?type=${type}`;
    if (creatorId) {
      url += `&creator_id=${encodeURIComponent(creatorId)}`;
    }
    return url;
  },
  getPortfolioContentDetail: (sk: string, type: string, creatorId?: string) => {
    let url = `${API_URLS.portfolioContentDetail}/${ensureEncoded(sk)}?type=${type}`;
    if (creatorId) {
      url += `&creator_id=${encodeURIComponent(creatorId)}`;
    }
    return url;
  },
  getAllSubscriptionListOfParentUser: (isWhiteLabelWeb, getHostUrl) => {
    let url = `${API_URLS.user_subscribe}?is_white_label=false&hostName=null`;
    if (isWhiteLabelWeb) {
      url = `${API_URLS.user_subscribe}?is_white_label=true&hostName=${getHostUrl}`;
    }
    return url;
  },
  calendarLink: (provider: string) => `rest/calendar/oauth-url?provider=${provider}`,
  downloadTicketPDF: (ticketId: string) => `rest/tickets/${ticketId}/download`,
  emailTicket: (ticketId: string) => `rest/tickets/${ticketId}/email`,
  onlyUserData: (username) => {
    return `api/user_by_username/${username}?basic=true`;
  },
  subscriptionCouponCodeUsag: (code: string) => {
    return `rest/coupon/usage/${code}`
  },
  deletePaymentMethod: (paymentMethodId: string) =>
    `rest/v2/payment-methods/${encodeURIComponent(paymentMethodId)}`,
  checkPaymentStatusByIntent: (intentId: string) =>
    `${API_URLS.checkPaymentStatus}?intentId=${encodeURIComponent(intentId)}`
};

export enum CREATE_POST_TYPE {
  link = 'link',
  text = 'text',
  image = 'image',
  video = 'video',
  audio = 'audio',
  poll = 'poll',
  reel = 'reel',
  livestream = 'livestream',
  downloadable = 'downloadables',
  giveAway = 'giveaway',
  article = 'article',
  collaborative = 'collaborative',
  fundraiser = 'fundraiser'
}

export const messageEmailId = 'shashank@yopmail.com';
